/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EventSummary = {
    id?: string;
    title?: string;
    description?: string;
    date?: string;
    time?: string;
    location?: string;
    image?: string;
    eventType?: EventSummary.eventType;
    attendees?: number;
    maxAttendees?: number;
    price?: string;
    category?: string;
    featured?: boolean;
    status?: EventSummary.status;
};
export namespace EventSummary {
    export enum eventType {
        IN_PERSON = 'in-person',
        VIRTUAL = 'virtual',
        HYBRID = 'hybrid',
        WEBINAR = 'webinar',
        CONFERENCE = 'conference',
        WORKSHOP = 'workshop',
    }
    export enum status {
        DRAFT = 'draft',
        PUBLISHED = 'published',
        CANCELLED = 'cancelled',
        COMPLETED = 'completed',
    }
}

